import { Button, Col, Container, Row } from "react-bootstrap";
import Background from "../../image/background4.jpg";

export default function Sustainablility () {
    return(
        <>
        <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
        <Container>
            <Row className="justify-content-center section">
                <Col md="8"  className="image-over-section">
                    <h2 style={{textAlign:"center"}}>Design for Sustainability
                    </h2>
                    <p style={{textAlign:"center", fontSize:"1.25em"}}>
                    Sustainable Design is an outcome of observing and appreciating natural phenomena and interconnectedness. This approach enables individuals and institutions to create beautiful and enduring products, which are embedded with universal principles and yet address the needs of local context.
                    </p>
                </Col>
            </Row>
        </Container>
        </Container>
        <Container>
            <Row className="justify-content-center section" style={{borderTop:"1px solid #ddd"}}>
                <Col sm="12" md="8">
                    <h3 style={{textAlign:"center", marginBottom:"30px"}}>Featured Project: Ekam Eco Solutions
                    </h3>
                    <div className="video-container">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/rQhYIZAKi-0?si=WTE8BxwFi3WkCKDm" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    
                    </div>
                    <p style={{textAlign:"justify"}}>
                    Dr. Chariar launched Ekam Eco Solutions as a sanitation startup in 2013, with Uttam Banerjee and Sachin Joshi. The flagship product, Zerodor, is a waterless urinal he invented in 2010.
                    </p><p style={{textAlign:"justify"}}>Ekam Eco has completed 10,000+ installations for Zerodor in the last 3 years, and saved more than 500 million litres of water. For latest updates, follow them on Facebook and LinkedIn.
                    </p>
                </Col>
            </Row>

            <Row className="justify-content-center section" style={{borderTop:"1px solid #ddd"}}>
                <Col sm="12" md="10"><h3 style={{marginBottom:"30px"}}>Publications</h3>
                <p>
                <b>Eco-friendly Flame Retardant Treatments for Cellulosic Green Building Materials.</b> Naresh Kr Sharma, C S Verma, Vijayaraghavan M Chariar and Rajendra Prasad. Journal of Indoor and Built Environment, Sage USA, Vol. 24, No. 3, 422-432, 2015.
                </p>
                <p>
                <b>Study of Acceptance of Human Urine by Indian Farmers as a Soil Conditioner and Water Source.</b> Md Azizur Rahman, Vijayaraghavan M. Chariar. International Journal of Tropical Agriculture, Vol.33 No. 2 pp 1537-1548, 2015.
                </p>
                <Button href="./publications#journals">All Publications <i className="bi bi-arrow-right"></i></Button>
                </Col>
            </Row>

            <Row className="justify-content-center section" style={{borderTop:"1px solid #ddd"}}>
                <Col sm="12" md="10"><h3 style={{marginBottom:"30px"}}>Conferences</h3>
                <p>
                <b>Indo US Roundtable on Building Partnerships for Sustainability Solutions at Centre for Environment Education.</b> Ahmedabad, India, 19 October 2015. (Co-Organiser : Walton Sustainability Solutions Initiative, ASU and Rajesh Buch)
                </p>
                <p>
                <b>Bamboo Artisans' Training Workshop.</b> Assam, Meghalaya, Sikkim, Chhatisgarh and Maharashtra. May 2012 - March 2013. (Co-Organiser: KVIC and IIT Delhi)
                </p>
                <Button href="./publications#conferences">All Conferences <i className="bi bi-arrow-right"></i></Button>
                </Col>
            </Row>
        </Container>
        </>
    )
}